import { wktToGeoJSON } from "@terraformer/wkt";
import { ByDistanceQuery } from "../types";
import { WebLatLng } from "../types/location";

export type Locateable = {
  id: number;
  bounds?: string;
  lonlat?: string;
  centroid?: string;
  deltas?: {
    lat: number;
    lon: number;
  };
};

export const parseWKTPoint = (string = "") => {
  const coords = wktToGeoJSON(string);
  switch (coords.type) {
    case "Point":
      return coords.coordinates;
    default:
      return [];
  }
};

export const wktToCoordinate = (string = ""): WebLatLng => {
  const [longitude, latitude] = parseWKTPoint(string);
  return { latitude, longitude };
};

export const useAddUserLocationToQuery = <T extends ByDistanceQuery>(
  params?: T,
): { params?: T; enabled: boolean } => {
  return { params, enabled: true };
};
